import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';
import { Platform } from '@angular/cdk/platform';
import { LaunchNavigatorOptions, LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { DomSanitizer } from '@angular/platform-browser';
let k=1;
declare var google;
@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss'],
})
export class DeliveryComponent  {
  @ViewChild('map',{static: false}) mapElement: ElementRef;
  loader:boolean=false;
  marker:any;
  orderItems:any=[];
  deliveryItems:any=[];
  search;
  category;
  openDetailPop:boolean=false;
itemOrders:any=[];
userLatLng:any; 
bell:boolean;
custLatLng:any;
custLat:any;
mapView:boolean = true;
map: any;
CalDate ;
date=new Date();
dateFormat;
currentDate;
lat;
lan;

  constructor(public auth: AuthService,public location: LocationService,private router: Router, public handler: HandlerService,
    public service: ApiService,private camera: Camera,private bottomSheet: MatBottomSheet,private platform: Platform,
    private launchNavigator: LaunchNavigator,public sanitizer: DomSanitizer) { }

ionViewWillEnter(){
  this.loader=true;
  this.CalDate = this.returnDate(this.date);
  this.currentDate = this.returnDate(this.date);
this.getCategory();
}


next() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() + 1));
    this.date = newDate;
    k=1;
  this.getAllOrder(this.date)
}

prev() {
  let x = new Date(JSON.parse(JSON.stringify(this.date)));
  let newDate = new Date(x.setDate(x.getDate() - 1));
  this.date = newDate
  k=1;
  this.getAllOrder(this.date)
}



returnDate(data) {
  let date = data.getDate();
  date = date < 10 ? '0' + date : date;
  let month = data.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let year = data.getFullYear();
  return year + '-' + month + '-' + date;
}

getCategory() {
  this.loader=true;
  this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
    this.category = res;
    this.getAllOrder(this.date);
  })
}

getAllOrder(date) {
  this.loader=true;
  k=1;
  this.service.getAllOrderByDateAndType(this.returnDate(date),k).subscribe((res: any) => {
    if(res){
      res.map(dat=>{
        var a = dat.orderDate.split("T");
        Object.assign(dat,{date:a[0],present:false});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(todaysDate < inputDate1){
          Object.assign(dat,{present:true});
        }
      })
    this.orderItems = res;
    this.orderItems = this.orderItems.filter(res=>{ return (res.status==4 || res.status==2||res.status==6||res.status==11||res.status==12) && res.orderType==2})
    this.orderItems.map(res => {
      Object.assign(res, { clicked: false })
    })  
    this.orderItems.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
     if(dat.paymtStatus==1)
     Object.assign(dat, {payStatusName: "Not Paid"})
     if(dat.paymtStatus==2)
     Object.assign(dat, {payStatusName: "Paid"})    
     if(dat.status==7)
     Object.assign(dat, {reqStatusName:"Pending"})   
     if(dat.status==2)
     Object.assign(dat, {reqStatusName:"Shipped"})
     if(dat.status==5)
     Object.assign(dat, {reqStatusName:"Cancelled"})
     if(dat.status==6)
     Object.assign(dat, {reqStatusName:"Returned"})   
     if(dat.status==9)
     Object.assign(dat, {reqStatusName:"Assigned"})
     if(dat.status==4)
     Object.assign(dat, {reqStatusName:"Delivered"})
     if(dat.status==12)
     Object.assign(dat, {reqStatusName:"Allocated"})
     if(dat.appt==true)
     Object.assign(dat, {serviceFlat:dat.flatName})
     if(dat.appt==false)
     Object.assign(dat, {serviceFlat:dat.street})
     if(dat.appt=="" || dat.appt== undefined )
     Object.assign(dat, {serviceFlat:"Not Specified"})
    })
    this.loader=false;
  } else{
    this.loader=false;
    this.orderItems=[];
    this.handler.res('No Data For You')
  } 
  }) 
}

  refreshData(event){
   this.ionViewWillEnter();   
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

popUpOpen(data){
  this.itemOrders = data.itemOrders;
  this.openDetailPop = true;
}

openPurchaseItems(data){
  this.router.navigate(['/purchase-ItemsList/',data.id])
  }

  orderDispatch(data){
    this.service.dispatchOrder(data.id).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully!!!');
    this.getAllOrder(this.date);
    })
  }

openMap(data) {
  if (this.platform.ANDROID || this.platform.IOS) {
    navigator.geolocation.getCurrentPosition(res => {
     this.lat = res.coords.latitude, 
     this.lan = res.coords.longitude;
    },
      err => {
        this.handler.err(err)
      })
  }
  var cLat = data?.address?.lat;
  var cLon = data?.address?.lon;
  if(cLat != "" && cLon != "" ){
    this.mapView=false;
    setTimeout(() => {
      this.userLatLng = [this.lat, this.lan];
      this.custLat = [cLat,cLon];
      this.custLatLng = new google.maps.LatLng(cLat,cLon);
      let pos = new google.maps.LatLng(this.lat, this.lan);
      let mapOptions = {
        center: pos,
        zoom: 100,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: pos,
        animation: google.maps.Animation.DROP,
        map: this.map
      });
      this.startNavigating(pos)
    }, 2000);
  }else{
    var err="Address Not Found"
    this.handler.err(err)
  }
}

startNavigating(pos) {
  let directionsService = new google.maps.DirectionsService;
  let directionsDisplay = new google.maps.DirectionsRenderer;
  directionsDisplay.setMap(this.map);
  directionsService.route({
    origin: pos,
    destination: this.custLatLng,
    travelMode: google.maps.TravelMode['DRIVING']
  }, (res, status) => {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(res);
    } else {
    }
  });
}

navigate(){
  let options: LaunchNavigatorOptions = {
    start: this.userLatLng,
  }
  this.launchNavigator.navigate(this.custLat, options)
    .then(
      success => this.mapView = false
    );
}
}